module.exports = __webpack_public_path__ + "static/img/header-es.fac9b76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-es.jpg
// module id = 510
// module chunks = 1 2 3 4 5 6